module.exports = __webpack_public_path__ + "img/b5-3.7e4a40b.png";